if (typeof class_a != 'function') {
  class EditorialSection extends HTMLElement {
    constructor() {
      super();

      this.swiperRef = new Swiper('.swiper', {
        // Optional parameters
        loop: true,
        pagination: true,
        // If we need pagination
        pagination: {
          el: '.swiper-pagination',
        },

        spaceBetween: 60,
        centeredSlides: true,

        // Navigation arrows
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },

        // And if we need scrollbar
        scrollbar: {
          el: '.swiper-scrollbar',
        },
      });
    }
  }

  if (!customElements.get('editorial-section')) {
    customElements.define('editorial-section', EditorialSection);
  }
}
